"use client";

import { cn } from "@/lib/utils";
import { Extensions, JSONContent } from "@tiptap/react";
import * as React from "react";
import { contentStyles } from "./base-editor/components/content-styles";
import { generateHTML } from "@tiptap/react";
import styles from "./feed.module.css";

type JSONRendererProps = {
	json: JSONContent | string;
	className?: string;
	extensions?: Extensions;
};

const JSONContentRenderer = React.forwardRef<HTMLDivElement, JSONRendererProps>(
	({ json, className, extensions }, ref) => {
		const parseJSON = (input: JSONContent | string): JSONContent => {
			if (typeof input === "string") {
				try {
					return JSON.parse(input) as JSONContent;
				} catch {
					console.error("Invalid JSON string for content");
					return {};
				}
			}
			return input;
		};

		const renderContent = (node: JSONContent) => {
			if (!node) return null;

			return (
				<div
					ref={ref}
					className={cn(contentStyles.container.viewer, styles.feedPostV2, className)}
					dangerouslySetInnerHTML={{
						__html: generateHTML(node, extensions ?? []),
					}}
				></div>
			);
		};

		return <>{renderContent(parseJSON(json))}</>;
	}
);

JSONContentRenderer.displayName = "JSONContentRenderer";

export { JSONContentRenderer };
